module.exports = __webpack_public_path__ + "img/eryk.db422bcf.jpg";